export default __webpack_public_path__ + "static/media/blog-img106.57bd912c.jpg";